<template>
  <div>
    <transition name="alert" >
      <div class="upgrade-warning" v-if="showAlert && !isDismissed">
        <div class="alert-close-icon" @click="closeAlert" :title="$t('common.dismiss')">
          <i class="fa fa-times"></i>
        </div>
        <div class="billing-alert">
            <h4 class="alert-heading">{{ $t('pmd.hi') }}{{user.name}}! </h4>
            {{ $t('conversations.send.connectReconnectGoogleForGbp') }}
            <br/><br/>
            <div class="alert-actions">
              <button type="button" class="btn btn-success upgrade-btn" @click="handleResolve()">{{ $t('common.reconnect') }}</button>
            </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { User, Location } from '@/models';
import { trackGaEvent } from "@/util/helper";

export default {
  data(){
    return{
      showAlert: false,
    }
  },
  watch: {
    checkifScopeExist() {
      this.showAlert = this.checkifScopeExist;
    }
  },
  computed:{
    user() {
      const user = this.$store.state.user.user
      return user ? new User(user) : undefined
    },
    location() {
      return this.$store.getters['locations/getById'](this.$route.params.location_id);
    },
    isDismissed(){
      if(this.location && this.location.gmb_business_scope_warning && this.$route.path){
        if((this.location.gmb_business_scope_warning.seconds + 3600) * 1000 > +new Date() ){
          return true;
        }
      }
      return false;
    },
    checkifScopeExist() {
      return this.location && !this.location.gmb_business_scope_exist && this.location.gmb?.id
    }
  },
  methods:{
    async closeAlert(){
      const d = new Date();
      await Location.collectionRef().doc(this.location.id).update({
        gmb_business_scope_warning: d
      })
        trackGaEvent('GMBMessagingWarning', this.location.id, 'In-app warning: Dismissed', 1);
    },
    handleResolve(){
      this.showAlert = false;
      this.$router.push({name: 'integrations_settings'});
        trackGaEvent('GMBMessagingWarning', this.location.id, 'In-app warning: Resolving', 1);
    },
  }
}
</script>

<style scoped>
.upgrade-warning{
  position: fixed;
  bottom: 100px;
  left: 100px;
  background-color: #ffffff;
  padding: 8px 50px 8px 8px;
  z-index: 1000;
  box-shadow: 0px 5px 10px 6px rgba(0,0,0,0.2);
  border-radius: 10px;
  opacity: 0.9;
  transform: translateX(0);
  transition: all 0.8s ease-in-out;
}
.alert-heading{
  /* text-transform: uppercase; */
  font-size: 22px;
}
.billing-alert{
    background-color: #ffffff;
    border-left: 4px solid #e93d3d;
    padding: 12px 12px 12px 20px;
    line-height: 20px;
}
.upgrade-btn{
  margin-right: 20px;
}
.alert-close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  font-size: 20px;
  line-height: 20px;
  color: #aaa;
  z-index: 5;
}
.alert-close-icon:hover{
  color: #777;
}
.alert-actions{
  margin: 20px 0px;
}

.info-message{
  border-left: 4px solid #198bf5;
  padding: 8px;
  background-color: #eaf3fe;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.alert-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.alert-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}

.alert-enter .upgrade-warning,
.alert-leave-active .upgrade-warning{
  opacity: 0;
  /* transform: translateX(-100%); */
}
</style>
